import autoMode from "../assets/autoMode.svg"

function EmptyTransaction() {
  return (
    <div className="empty-trans">
         <img src={autoMode} alt="empty" />
         <h5 className="empty-trans-head">Your transaction history is currently empty!</h5>
         <div className="empty-trans-text">
         Once you start receiving payments, the transaction details will appear here.
         </div>
    </div>
  )
}

export default EmptyTransaction